import TemplateField from "./TemplateField";
import {parseShapeSettings} from "@frontend/group/modules/brand-colors/helper";

export class ShapeTemplateField extends TemplateField  {
    shapeSettings = null;

    constructor(fieldData) {
        super(fieldData);
        this.shapeSettings = parseShapeSettings(this.options);
    }

    getStrokeWidth() {
        return this.shapeSettings.stroke_width ?? (+this.options.option2 || 0);
    }
}
